import { packingField } from "./packingFormField";
import { useEffect, useState } from "react";
import { getPackingSizeData } from "../../../services/packing/packing";
import { getpackingDataAPI } from "../../../services/packing/packing";
import { toast } from "../../../components/AppToast";
import { getPkgIdData } from "../../../services/packing/packing";
export default function CreatePackaging({ initialValues, onSubmit, onCancel, viewOnly, isEdit }) {
    const [packageSize, setPackageSize] = useState();
    const [pkgReadOnly, setPkgReadOnly] = useState();
    const [pckgId, setPkgID] = useState();
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [formData, setFormData] = useState({
        pkgId: '',
        pkgType: '',
        pkgSize: '',
        dimensions: '',
        marketplace: '',
        volumeCapacity: '',
        weightCapacity: '',
        exclusion: '',
        costPerUnit: '',
        createdBy: '',
        updatedBy: '',
        updatedDate: '',
    })


    const handleChange = async (name, value) => {
        setFormData({ ...formData, [name]: value });
        if (name == 'pkgType') {
            setPkgID(null);
            setPackageSize(null);
            setFormData(prev => ({
                pkgId: '',
                pkgType: value,
                pkgSize: '',
                dimensions: '',
                marketplace: '',
                volumeCapacity: '',
                weightCapacity: '',
                exclusion: '',
                costPerUnit: '',
                createdBy: '',
                updatedBy: '',
                updatedDate: '',
            }));
            if (value != "") {
                await getPackingSize(value);
                await getPkgIdDataFn(value);
            }
            else {
                setPkgReadOnly(true);
            }
        }

        if (name == 'pkgId') {
            await getPkgData({ pkgId: value, pkgType: formData.pkgType })
        }
    }

    const getPkgData = async (data) => {
        try {
            const response = await getpackingDataAPI(data);
            // console.log(response, "response");
            setFormData(prev => ({
                ...prev,
                dimensions: response.data.dimensions,
                exclusion: response.data.exclusions,
                volumeCapacity: response.data.volCapacity,
                weightCapacity: response.data.weightCapacity,
                pkgSize: response.data.pkgSize
            }));
        }
        catch (err) {
            console.error(err, "error")
            if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    }

    const getPackingSize = async (value) => {
        try {
            const response = await getPackingSizeData({ pkgType: value });
            // console.log(response, "response");
            if (response.length > 0) {
                setPackageSize(response[0].sizes)
            }

        } catch (err) {
            console.log(err, "error");

            if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    };


    const getPkgIdDataFn = async (value) => {
        try {
            const response = await getPkgIdData({ pkgType: value });
            // console.log(response, "response");
            if (response.success == true) {
                setPkgReadOnly(false);
                setPkgID(response.data)
            }

        } catch (err) {
            // console.log(err, "error");

            if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    }


    const submit = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                const finalData = {...formData,updatedBy:loggedInUser};
                await onSubmit(finalData, initialValues._id);
            } else {
                const finalData = {...formData,createdBy:loggedInUser};
                await onSubmit(finalData);
            }
        } catch (err) {
            if (err?.data?.message) {
                toast.error(err.data.message);
            } else {
                toast.error("Error saving carton");
            }
        }
    }


    useEffect(() => {

        if ((viewOnly || isEdit) && initialValues) {
            setPackageSize(null);
            getPackingSize(initialValues.pkgType);
            getPkgIdDataFn(initialValues.pkgType)
            setFormData({ ...initialValues, volumeCapacity: initialValues.volCapacity,updatedDate:initialValues.updatedAt });
        }
    }, [viewOnly, isEdit, initialValues])


    useEffect(() => {
         const loggedInUserDetails = JSON.parse(localStorage.getItem('persist:root'));
            setLoggedInUser(JSON.parse(loggedInUserDetails.login).userDetail.username);
        if (formData.pkgType == "") {
            setPkgReadOnly(true);
        }

        if(!viewOnly && !isEdit){
            formData.createdBy=loggedInUser;
        }
           
    })

    return (
        <form>
            <div className="d-flex flex-wrap gap-3">
                {packingField.map((field) => (
                    <div
                        key={field.name}
                        className="mb-1"
                        style={{ flex: `0 0 ${field.width || "15%"}` }}

                    >
                        <label className="form-label">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                        </label>

                        {field.type === 'select' ? (
                            <select
                                className="form-select"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                disabled={viewOnly || isEdit || field.readonly}
                            >
                                <option value="" style={{ fontSize: '12px' }}>Select</option>

                                {field.name === 'pkgType' && field.option?.map((opt) => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}

                                {field.name === 'pkgSize' && packageSize?.map((opt) => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}


                            </select>
                        ) : field.type === 'pkID' ? (
                            <select
                                className="form-select"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                disabled={viewOnly || isEdit || pkgReadOnly}
                            >
                                <option value="" style={{ fontSize: '12px' }}>Select</option>

                                {field.name === 'pkgId' && pckgId?.map((opt) => (
                                    <option key={opt.pkgId} value={opt.pkgId}>{opt.pkgId}</option>
                                ))}

                            </select>
                        ) :
                            (<input
                                type={field.type || "text"}
                                className="form-control"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                readOnly={viewOnly || field.readonly}
                            />)
                        }
                    </div>
                ))}
            </div>

            <div className="d-flex justify-content-center gap-2 mt-3">
                <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
                <button
                    className="btn btn-primary"
                    onClick={submit}

                    style={{ display: !viewOnly && !isEdit ? 'inline-flex' : 'none' }}
                >
                    Save
                </button>


                <button className="btn btn-primary"
                    onClick={submit}
                    style={{ display: isEdit && !viewOnly ? 'inline-flex' : 'none' }}
                >
                    Update
                </button>
            </div>
        </form>
    )
}
